import axios from 'axios'

const apiConfig = {
  baseURL: process.env.VUE_APP_API_URL
}

if (process.env.VUE_APP_BASIC_AUTH && JSON.parse(process.env.VUE_APP_BASIC_AUTH)) {
  apiConfig.auth = {
    username: process.env.VUE_APP_USERNAME,
    password: process.env.VUE_APP_PASSWORD
  }
} else {
  apiConfig.withCredentials = true
}

const api = axios.create(apiConfig)

export default api